import axios from "axios";
import { API } from "@/lib/api";

const KEY = "portal_token";
export const getPortalToken = () => localStorage.getItem(KEY);
export const setPortalToken = (t) => (t ? localStorage.setItem(KEY, t) : localStorage.removeItem(KEY));

export const portalApi = axios.create({ baseURL: `${API}/portal` });

portalApi.interceptors.request.use((config) => {
  const t = getPortalToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

portalApi.interceptors.response.use(
  (r) => r,
  (e) => {
    const url = e.config?.url || "";
    if (e.response?.status === 401 && getPortalToken() && !url.includes("/auth/login") && !url.includes("/auth/magic")) {
      setPortalToken(null);
      window.location.href = "/portal/login";
    }
    return Promise.reject(e);
  }
);

export async function portalDownload(path, filename) {
  const { data } = await portalApi.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

export const docPdf = (d) => portalDownload(`/auth/documents/${d.id}/pdf?download=true`, `${(d.number || "document").replace(/\//g, "-")}.pdf`);

export function loadCheckout() {
  if (window.Razorpay) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = resolve;
    s.onerror = () => reject(new Error("Could not load Razorpay. Check your connection."));
    document.body.appendChild(s);
  });
}
